import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { RouterModule } from '@angular/router';

import { SLHomeComponent } from './sl-home.component';
import { CLClientModule } from './client';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    RouterModule,
    CLClientModule,
  ],
  declarations: [
    SLHomeComponent
  ],
  providers: [
  ],
})
export class SLModule { }
